import { API_URL } from '../../app/apiConfig';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = { 'content-type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export function createUser(userData) {
  return new Promise(async (resolve) => {
    const response = await fetch(`${API_URL}/api/auth/signup`, {
      method: 'POST',
      body: JSON.stringify(userData),
      headers: { 'content-type': 'application/json' },
      credentials: 'include',
    });
    const data = await response.json();
    resolve({ data });
  });
}

export function loginUser(loginInfo) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        body: JSON.stringify(loginInfo),
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
      });
      if (response.ok) {
        const data = await response.json();
        resolve({ data });
      } else {
        const error = await response.text();
        reject(error);
      }
    } catch (error) {
      reject(error?.message || 'Network error: could not connect to server');
    }

  });
}

export function checkAuth() {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = getAuthHeaders();
      const response = await fetch(`${API_URL}/api/auth/check`, {
        headers,
        credentials: 'include',
      });
      if (response.ok) {
        const data = await response.json();
        resolve({ data });
      } else {
        const error = await response.text();
        reject(error);
      }
    } catch (error) {
      reject(error?.message || 'Network error: could not check authentication');
    }

  });
}


export function signOut(userId) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/logout`, {
        credentials: 'include',
      });
      if (response.ok) {
        resolve({ data:'success' });
      } else {
        const error = await response.text();
        reject(error);
      }
    } catch (error) {
      reject(error?.message || 'Logout failed');
    }
  });
}


export function resetPasswordRequest(email) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/reset-password-request`, {
        method: 'POST',
        body: JSON.stringify({email}),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        resolve({ data });
      } else {
        const error = await response.text();
        reject(error);
      }
    } catch (error) {
      reject(error?.message || 'Network error: could not request password reset');
    }

  });
}

export function resetPassword(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/reset-password`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        resolve({ data });
      } else {
        const error = await response.text();
        reject(error);
      }
    } catch (error) {
      reject(error?.message || 'Network error: could not reset password');
    }

  });
}
export function sendOTP(email) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/send-otp`, {
        method: 'POST',
        body: JSON.stringify({ email }),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        resolve({ data });
      } else {
        const error = await response.json();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function verifyOTP(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/verify-otp`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const responseData = await response.json();
        resolve({ data: responseData });
      } else {
        const error = await response.json();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function createUserWithOTP(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/signup-with-otp`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const responseData = await response.json();
        resolve({ data: responseData });
      } else {
        const error = await response.json();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function sendPasswordResetOTP(email) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/send-password-reset-otp`, {
        method: 'POST',
        body: JSON.stringify({ email }),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const data = await response.json();
        resolve({ data });
      } else {
        const error = await response.json();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function verifyPasswordResetOTP(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/verify-password-reset-otp`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const responseData = await response.json();
        resolve({ data: responseData });
      } else {
        const error = await response.json();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function resetPasswordWithOTP(data) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/auth/reset-password-with-otp`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
      });
      if (response.ok) {
        const responseData = await response.json();
        resolve({ data: responseData });
      } else {
        const error = await response.json();
        reject(error);
      }
    } catch (error) {
      reject(error);
    }
  });
}
